import { VisitorSegments } from './lib/VisitorSegments';

export default VisitorSegments;
export * from './lib/api';
export * from './lib/types';
